<script lang="ts">
  import {
    ChevronLeft,
    House,
    Computer,
    Menu,
    Image,
    Users,
    Rows4,
    BookOpen,
    Video,
    MessageSquareMore,
    List
  } from "lucide-svelte"

  import logo from "@images/logo/logo_white_small.png"

  export let controller: string

  const menuItems = [
    {
      name: "Dashboard",
      icon: House,
      controller: "dashboard",
      href: "/admin"
    },
    {
      name: "Website Content",
      icon: Computer,
      controller: "website_content",
      href: "/admin/website_content"
    },

    {
      name: "Plans",
      icon: Menu,
      controller: "plans",
      href: "/admin/plans"
    },
    {
      name: "Symbols",
      icon: Image,
      controller: "plan_symbols",
      href: "/admin/plan_symbols"
    },
    {
      name: "Users",
      icon: Users,
      controller: "Users",
      href: "/admin/users"
    },
    {
      name: "Alignment Tests",
      icon: List,
      controller: "alignment_test",
      href: "/admin/alignment_tests"
    },
    {
      name: "Subscriptions",
      icon: Rows4,
      controller: "subscriptions",
      href: "/admin/subscriptions"
    },
    {
      name: "Bookshelf",
      icon: BookOpen,
      controller: "books",
      href: "/admin/books"
    },
    {
      name: "Videos",
      icon: Video,
      controller: "videos",
      href: "/admin/videos"
    },
    {
      name: "Community Forum",
      icon: MessageSquareMore,
      controller: "community",
      href: "/admin/community"
    }
  ]
</script>

<div class="flex bg-slate-900">
  <div class="w-80 ring-1 ring-white/5">
    <nav class="px-4 py-6 h-screen">
      <div class="flex items-center justify-center mb-8">
        <a href="/admin" class="text-xl font-bold">
          <img src={logo} width="120" alt="Home" />
        </a>
      </div>
      <ul>
        {#each menuItems as item}
          {@const Icon = item.icon}
          <li class="hover:bg-slate-800">
            <a
              href={item.href}
              class="flex items-center {item.controller === controller
                ? 'text-white font-semibold'
                : 'text-gray-400'}"
            >
              <Icon
                class="size-5"
                color={item.controller === controller ? "white" : "#666"}
              />

              {item.name}
            </a>
          </li>
        {/each}
        <li class="mt-8 border-t border-gray-600 py-2">
          <a
            href="/"
            class="flex items-center gap-x-4 px-6 py-3 text-base font-semibold leading-6 text-gray-400 hover:bg-gray-800"
          >
            <ChevronLeft class="w-5 h-5" />
            <span class="sr-only">Exit Admin</span>
            <span aria-hidden="true">Exit Admin</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>

  <div class="w-full bg-indigo-50">
    <div class="p-4 mt-4">
      <div class="mx-auto px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-lwp-blue">
          <slot name="title" />
        </h1>
      </div>
    </div>

    <div class="pt-4 pb-16 px-12">
      <slot />
    </div>
  </div>
</div>

<style lang="postcss">
  nav li a {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem;
  }
</style>
